module.exports = __webpack_public_path__ + "static/media/factory-heart.88a3c668.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/GetAShareResources/factory-heart.svg
// module id = 185
// module chunks = 0